export const transportUnitRef = (index: number): string => `$['transport_units'][${index}]`;
export const lineItemRef = (index: number): string => `$['line_items'][${index}]`;

export const refIndex = (ref: string | undefined): number | null => {
  const match = ref?.match(/\[(\d+)\]$/);
  return match ? Number(match[1]) : null;
};
